import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import enterprise_img from '../../../../assets/image/youthVentureProgram_img.jpg';
import SubTab from '../SubTab/SubTab';

const YouthVentureProgram = () => {
  const category = 'youthVentureProgram';
  const [select, setSelect] = useState(0);
  const navigate = useNavigate();
  const handleSelect = (num) => {
    if (select === num) {
      setSelect(0);
    } else {
      setSelect(num);
    }
  };
  const moveBoard = (cate) => {
    navigate(`/board/${cate}`, { state: { cate: cate } });
  };
  const movePage = (path) => {
    navigate(path);
  };

  return (
    <div className="sub_wrap">
      <div className="sub_back">
        <div className="sub_banner_area">
          <div className="sub_banner_back">
            <div className="navi_text">
              <div className="home_icon_sub"></div>
              {'> '}사업분야{' > '}창업 육성 사업
            </div>
            <div className="banner_main_text">창업 육성 사업</div>
          </div>
        </div>
        <div className="navi_area">
          <div className="navi_back">
            <div className="navi_box business_field" onClick={() => handleSelect(1)}>
              <div className="navi_main_text">창업육성사업</div>
              <div className="navi_arrow"></div>
              <div className={`navi_select_box ${select === 1 && 'active'}`}>
                <div className="select_row" onClick={() => movePage('/fusionSupportProgram')}>
                  산학융합지구조성사업
                </div>
                <div className="select_row" onClick={() => movePage('/business/chungnamInnovationProject')}>
                  기업지원사업
                </div>
                <div className="select_row" onClick={() => movePage('/business/localIndustryTalentDevelopment')}>
                  인재양성사업
                </div>
                <div className="select_row" onClick={() => movePage('/business/dangjinStartupSupport')}>
                  창업육성사업
                </div>
              </div>
            </div>
            <div className="navi_box founded" onClick={() => handleSelect(2)}>
              <div className="navi_main_text">당진시 청년도전지원사업</div>
              <div className="navi_arrow"></div>
              <div className={`navi_select_box ${select === 2 && 'active'}`}>
                <div className="select_row" onClick={() => movePage('/business/dangjinStartupSupport')}>
                  당진시 창업지원사업
                </div>
                <div className="select_row" onClick={() => movePage('/business/youthVentureProgram')}>
                  당진시 청년도전지원사업
                </div>
                <div className="select_row" onClick={() => movePage('/business/MiddleAgedStartupCenter')}>
                  당진시 중장년기술창업센터
                </div>
                <div className="select_row" onClick={() => movePage('/business/YouthEmploymentSupport')}>
                  당진시 청년 취·창업 지원사업
                </div>
                {/* <div className="select_row" onClick={() => movePage('/business/DangjinYouthChallenge')}>
                  당진시 청년도전지원사업
                </div> */}
                <div className="select_row" onClick={() => movePage('/business/YouthGrowthProject')}>
                  당진시 청년성장 프로젝트
                </div>
                <div className="select_row" onClick={() => movePage('/business/HongseongYouthGrowth')}>
                  홍성군 청년성장 프로젝트
                </div>
                {/* <div className="select_row" onClick={() => movePage('/business/HongseongCultureStartup')}>
                  홍성군 복합문화창업공간 잇슈창고
                </div> */}
                <div className="select_row" onClick={() => movePage('/business/HongseongJobAdaptation')}>
                  홍성군 직장적응 지원사업
                </div>
                {/* <div className="select_row" onClick={() => movePage('/business/hopeReturnPackage')}>
                  희망리턴패키지 사업
                </div> */}
                <div className="select_row" onClick={() => movePage('/business/hongseongIssueWarehouse')}>
                  홍성군 잇슈창고운영사업
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="sub_main_area temporary">
          <SubTab category={category} />
          {/* 🔹 공통으로 돌려 쓸 카드 헤더(리디자인 영역) */}
          <div className="business-hero">
            <div className="business-hero-inner">
              <p className="business-hero-tag">Dangjin Youth Challenge Program</p>
              <h2 className="business-hero-title">당진시 청년도전지원사업</h2>
              <p className="business-hero-period">사업기간 : (계속사업) 2024. 3. 1.~2026. 12. 31.</p>
              <p className="business-hero-period">담당부처: 고용노동부</p>
            </div>
          </div>
          <div className="sub_main_back">
            <div className="vision_container">
              <div className="vision_title_box nonline">
                <div className="logo_box">
                  <div className="logo_img"></div>
                </div>
                <div className="title_text">사업내용</div>
              </div>
              <div>
                <div className="youth-img2"></div>
              </div>
              <div className="vision_title_box nonline">
                <div className="logo_box">
                  <div className="logo_img"></div>
                </div>
                <div className="title_text">추진체계 및 사업목표</div>
              </div>
              <div className="propulsion_box">
                <div>
                  <div className="youth-img3"></div>
                </div>
              </div>
              <div className="vision_title_box nonline">
                <div className="logo_box">
                  <div className="logo_img"></div>
                </div>
                <div className="title_text">성과 부문</div>
              </div>
              <div className="local_final_result_box">
                <div className="project-result-box table-container ">
                  <table className="project-result-table">
                    <thead>
                      <tr>
                        <th style={{ width: '20%' }}>구분</th>
                        <th style={{ width: 'calc((100% - 33.333%) / 3)' }}>세부사업</th>
                        <th style={{ width: 'calc((100% - 33.333%) / 3)' }}>2023</th>
                        <th style={{ width: 'calc((100% - 33.333%) / 3)' }}>2024</th>
                        <th style={{ width: 'calc((100% - 33.333%) / 3)' }}>2025</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr>
                        <td rowSpan={2}>참여자 발굴</td>
                        <td>참여 신청</td>
                        <td>91건</td>
                        <td>145건</td>
                        <td>240건</td>
                      </tr>
                      <tr>
                        <td>참여 승인</td>
                        <td>59건</td>
                        <td>81건</td>
                        <td>119건</td>
                      </tr>
                      <tr>
                        <td rowSpan={3}>프로그램 운영</td>
                        <td>단기 프로그램(5주)</td>
                        <td>22명</td>
                        <td>25명</td>
                        <td>31명</td>
                      </tr>
                      <tr>
                        <td>중기 프로그램(15주)</td>
                        <td>-</td>
                        <td>35명</td>
                        <td>56명</td>
                      </tr>
                      <tr>
                        <td>장기 프로그램(25주)</td>
                        <td>37명</td>
                        <td>21명</td>
                        <td>32명</td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default YouthVentureProgram;
